import React, { useEffect, useState } from "react";
import firstFunctionalityFirstImage from "../../assets/images/first-fuctionality-image-set.png";
import firstFunctionalitySecondImage from "../../assets/images/first-functionality-second-image-set.png";
import secondFunctionalityFirstImage from "../../assets/images/second-functionality-first-image-set.png";
import secondFunctionalitySecondImage from "../../assets/images/second-functionality-second-image-set.png";
import "./Functionality.css";
import { Modal } from "antd";
import "../Buttons/Modal.css";
import DownloadOnGooglePlay from "../Buttons/DownloadOnGooglePlay";
import DownloadOnAppStore from "../Buttons/DownloadOnAppStore";
import { FaAngleRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import DownloadOnAppStoreMobile from "../Buttons/DownloadOnAppStoreMobile";
import DownloadOnGooglePlayMobile from "../Buttons/DownloadOnGooglePlayMobile";

const Functionality = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div className="functionality-container" id="trade">
      <div className="first-functionality-details">
        <div
          className="first-functionality-image"
          data-aos="fade-right"
          data-aos-duration="1000"
        >
          <img
            src={firstFunctionalityFirstImage}
            alt="Sportrex Trade"
            className="first-functionality-left"
            data-aos="fade-right"
            data-aos-duration="2500"
          />
          <img
            src={firstFunctionalitySecondImage}
            alt="Sportrex Trade"
            className="first-functionality-right"
            data-aos="fade-right"
            data-aos-duration="4000"
          />
          {/* <img src={functionalityFirstImage} alt="functionality Illustration" /> */}
        </div>
        <div
          className="first-functionality-text"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <h4>
            {t("Own")} {t("and")} {t("trade")} {t("your")} {t("in")}-{t("game")}{" "}
            {t("Assets")}.
          </h4>
          <p>
            {t("Game")} {t("on")}, {t("earn")} {t("on")}! Sportrex Gamers Wallet{" "}
            {t("is")} {t("the")} {t("secure")} {t("and")} {t("easy")} {t("way")}{" "}
            {t("to")} {t("store")} {t("and")} {t("manage")} {t("your")}{" "}
            {t("in")}-{t("game")} {t("winnings")}. {t("Whether")} {t("youre")}{" "}
            {t("a")} {t("competitive")} {t("gamer")} {t("or")} {t("just")}{" "}
            {t("a")} {t("casual")} {t("player")}, Sportrex {t("has")}{" "}
            {t("something")} {t("for")} {t("everyone")}. Sportrex Gamers Wallet{" "}
            {t("effortlessly")} {t("converts")} {t("your")} {t("winnings")}{" "}
            (Game NFTs) {t("into")}
            {t("your")} {t("preferred")} {t("cryptocurrency")}.
            <br /> <br />
            <strong onClick={showModal} className="earn-text" id="connect">
              {t("Download")} Sportrex Gamers Wallet {t("and")} {t("start")}{" "}
              {t("earning")}! <FaAngleRight className="earn-icon" />
            </strong>
          </p>
        </div>
      </div>
      <div className="second-functionality-details">
        <div
          className="second-functionality-text"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <h4>
            {t("Exclusive")} {t("content")} {t("and")} {t("experiences")},{" "}
            {t("now")} {t("at")} {t("your")} {t("fingertips")}.
          </h4>
          <p>
            Sportrex Gamers Wallet {t("is")} {t("your")} {t("passport")}{" "}
            {t("to")} {t("unlock")} {t("exclusive")} {t("content")} {t("and")}{" "}
            {t("experiences")} {t("for")} {t("your")} {t("favourite")}{" "}
            {t("games")}. {t("All")} {t("you")} {t("need")} {t("to")} {t("do")}{" "}
            {t("is")} {t("connect")} {t("your")} Sportrex Gamers Wallet{" "}
            {t("to")} {t("your")} Sportrex {t("Gaming")} {t("account")}{" "}
            {t("or")} {t("any")} {t("other")} {t("Gaming")} {t("Platform")}{" "}
            {t("account")}. {t("Once")} {t("connected")} {t("youll")}, {t("be")}{" "}
            {t("able")} {t("to")} {t("start")} {t("earning")} {t("rewards")}{" "}
            {t("and")} {t("unlocking")} {t("exclusive")} {t("content")}{" "}
            {t("instantly")}.
            <br />
            <br />
            <strong onClick={showModal} className="earn-text">
              {t("Download")} Sportrex Gamers Wallet {t("today")} {t("and")}{" "}
              {t("start")} {t("enjoying")} {t("the")} {t("perks")}!{" "}
              <FaAngleRight className="earn-icon" />
            </strong>
          </p>
        </div>
        <div
          className="second-functionality-image"
          data-aos="fade-left"
          data-aos-duration="3000"
        >
          <img
            src={secondFunctionalityFirstImage}
            alt="Sportrex Trade"
            className="second-functionality-left"
            data-aos="fade-left"
            data-aos-duration="2500"
          />
          <img
            src={secondFunctionalitySecondImage}
            alt="Sportrex Trade"
            className="second-functionality-right"
            data-aos="fade-left"
            data-aos-duration="4000"
          />
        </div>
      </div>
      <Modal
        className="download-button-modal"
        footer={null}
        open={isModalOpen}
        onCancel={handleCancel}
      >
        <div className="download-modal-details">
          <h4>
            {t("Download")} Sportrex Gamers Wallet {t("and")} {t("earn")}{" "}
            {t("free")} <span>SPT Token</span>
          </h4>
          <div className="download-buttons">
            <DownloadOnAppStoreMobile />
            <DownloadOnGooglePlayMobile />
            <DownloadOnGooglePlay />
            <DownloadOnAppStore />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Functionality;
